// src/screens/EditarProveedorScreen.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { doc, getDoc, updateDoc, deleteDoc, Timestamp } from 'firebase/firestore';
// eslint-disable-next-line no-unused-vars
import { IoArrowBack, IoTrash, IoSave, IoCalendarOutline, IoTimeOutline, IoRefresh, IoCheckmarkCircle, IoAlertCircle } from 'react-icons/io5';
import './NuevoProveedorScreen.css'; // Reutilizamos estilos premium

// Helpers
const getTodayString = () => new Date().toISOString().split('T')[0];
// eslint-disable-next-line no-unused-vars
const getMaxDateString = () => {
  const d = new Date(); d.setDate(d.getDate() + 90); return d.toISOString().split('T')[0];
};

// Opciones (Mismas de Nuevo)
const SERVICIOS_HOGAR = [
  "Jardinero", "Plomero", "Electricista", "Servicios Domésticos",
  "Carpintero", "Albañil", "Pintor", "Herrero", "Niñera",
  "Paseador de Perros", "Otro, especifique"
];

function EditarProveedorScreen() {
  const navigate = useNavigate();
  const { accesoId } = useParams();
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);

  // Datos Info
  const [tipoProveedor, setTipoProveedor] = useState('');
  const [nombreComercial, setNombreComercial] = useState('');
  const [nombres, setNombres] = useState('');
  const [apellidos, setApellidos] = useState('');
  const [tipoServicio, setTipoServicio] = useState('');
  const [otroServicio, setOtroServicio] = useState('');
  const [contacto, setContacto] = useState('');

  // Datos Fechas (Visualización/Renovación)
  // eslint-disable-next-line no-unused-vars
  const [currentInicio, setCurrentInicio] = useState(null);
  const [currentFin, setCurrentFin] = useState(null);

  // Estado para Extension
  const [diasExtension, setDiasExtension] = useState('3');

  // Estado para Renovación
  const [isRenovating, setIsRenovating] = useState(false);
  const [newInicio, setNewInicio] = useState(getTodayString());
  const [newFin, setNewFin] = useState(getTodayString());

  useEffect(() => {
    const cargarDatos = async () => {
      const docRef = doc(db, "accesos", accesoId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setTipoProveedor(data.tipoProveedor);
        setNombreComercial(data.nombreComercial || '');
        if (data.nombreCompleto) {
          const parts = data.nombreCompleto.split(' ');
          setNombres(parts[0]);
          setApellidos(parts.slice(1).join(' '));
        }
        setContacto(data.contacto);

        if (SERVICIOS_HOGAR.includes(data.tipoServicio)) {
          setTipoServicio(data.tipoServicio);
        } else {
          setTipoServicio('Otro, especifique');
          setOtroServicio(data.tipoServicio);
        }

        setCurrentInicio(data.fechaInicio?.toDate());
        setCurrentFin(data.expira?.toDate());
        setLoading(false);
      } else {
        alert("Acceso no encontrado."); navigate('/accesos/proveedores');
      }
    };
    cargarDatos();
  }, [accesoId, navigate]);

  const handleUpdateInfo = async (e) => {
    e.preventDefault();
    setProcessing(true);
    const nombreFinalServicio = tipoServicio === 'Otro, especifique' ? otroServicio : tipoServicio;
    const nombreFinalProveedor = tipoProveedor === 'Empresa' ? nombreComercial : `${nombres} ${apellidos}`;

    try {
      await updateDoc(doc(db, "accesos", accesoId), {
        tipoProveedor,
        nombreComercial: tipoProveedor === 'Empresa' ? nombreComercial : null,
        nombreCompleto: tipoProveedor === 'Particular' ? nombreFinalProveedor : null,
        tipoServicio: nombreFinalServicio,
        contacto
      });
      alert('Información actualizada.');
    } catch (e) { console.error(e); alert('Error al guardar.'); }
    finally { setProcessing(false); }
  };

  const handleExtender = async () => {
    if (!currentFin) return;
    const dias = parseInt(diasExtension);
    if (!window.confirm(`¿Extender acceso por ${dias} días mas? (Mismo QR)`)) return;

    setProcessing(true);
    try {
      // Sumar días a la fecha de fin actual
      const nuevaFin = new Date(currentFin);
      nuevaFin.setDate(nuevaFin.getDate() + dias);
      // Asegurar final del día
      nuevaFin.setHours(23, 59, 59);

      await updateDoc(doc(db, "accesos", accesoId), {
        expira: Timestamp.fromDate(nuevaFin),
        estatus: 'Activo' // Reactivar si estaba expirado
      });

      setCurrentFin(nuevaFin); // Update local
      alert('Vigencia extendida.');
    } catch (e) { console.error(e); alert('Error al extender.'); }
    finally { setProcessing(false); }
  };

  const handleRenovar = async () => {
    if (!window.confirm("¿Generar NUEVO Contrato y QR? El anterior dejará de funcionar.")) return;

    if (new Date(newFin) < new Date(newInicio)) { alert('Fechas inválidas.'); return; }

    setProcessing(true);
    try {
      const newToken = Math.floor(100000 + Math.random() * 900000).toString(); // 6 dígitos numéricos
      const ini = new Date(newInicio + 'T00:00:00');
      const fin = new Date(newFin + 'T23:59:59');

      await updateDoc(doc(db, "accesos", accesoId), {
        token: newToken,
        fechaInicio: Timestamp.fromDate(ini),
        expira: Timestamp.fromDate(fin),
        estatus: 'Activo',
        horarioInicio: '09:00', // Reafirmamos reglas
        horarioFin: '18:00'
      });

      alert(`¡Renovación Exitosa!\nNuevo Token: ${newToken}`);
      navigate('/accesos/proveedores');
    } catch (e) { console.error(e); alert('Error al renovar.'); }
    finally { setProcessing(false); }
  };

  const handleDelete = async () => {
    if (!window.confirm("¿Eliminar este proveedor permanentemente?")) return;
    try { await deleteDoc(doc(db, "accesos", accesoId)); navigate('/accesos/proveedores'); }
    catch (e) { alert('Error al eliminar'); }
  };

  if (loading) return <div className="new-prov-container"><p>Cargando...</p></div>;

  const isExpired = currentFin && currentFin < new Date();

  return (
    <div className="new-prov-container">
      <div className="new-prov-header">
        <button onClick={() => navigate('/accesos/proveedores')} className="new-back-btn"><IoArrowBack /></button>
        <h1 className="new-title">Editar Proveedor</h1>
      </div>

      <div className="new-prov-card">
        {/* Status Banner */}
        <div style={{
          background: isExpired ? '#fef2f2' : '#ecfdf5',
          border: `1px solid ${isExpired ? '#fee2e2' : '#d1fae5'}`,
          borderRadius: 12, padding: 16, display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24
        }}>
          {isExpired ? <IoAlertCircle size={24} color="#dc2626" /> : <IoCheckmarkCircle size={24} color="#059669" />}
          <div>
            <h4 style={{ margin: 0, color: isExpired ? '#991b1b' : '#065f46' }}>
              {isExpired ? 'Acceso Expirado' : 'Acceso Activo'}
            </h4>
            <p style={{ margin: 0, fontSize: '0.85rem', color: isExpired ? '#b91c1c' : '#047857' }}>
              Válido hasta: {currentFin?.toLocaleDateString()}
            </p>
          </div>
        </div>

        <form onSubmit={handleUpdateInfo} className="new-prov-form">
          {/* --- INFO PRINCIPAL (Nombre, Servicio, Contacto) --- */}
          <p style={{ fontWeight: 700, color: '#94a3b8', fontSize: '0.8rem', textTransform: 'uppercase', margin: 0 }}>Información General</p>

          <div className="form-group-grid">
            <div className="form-field">
              <label>Tipo</label>
              <select value={tipoProveedor} onChange={(e) => setTipoProveedor(e.target.value)} className="form-select">
                <option value="Empresa">Empresa</option>
                <option value="Particular">Particular</option>
              </select>
            </div>
            <div className="form-field">
              <label>Contacto</label>
              <input type="tel" value={contacto} onChange={(e) => setContacto(e.target.value)} className="form-input" maxLength={10} />
            </div>
          </div>

          {tipoProveedor === 'Empresa' ? (
            <div className="form-field"><label>Nombre Comercial</label><input type="text" value={nombreComercial} onChange={(e) => setNombreComercial(e.target.value)} className="form-input" /></div>
          ) : (
            <div className="form-group-grid">
              <div className="form-field"><label>Nombres</label><input type="text" value={nombres} onChange={(e) => setNombres(e.target.value)} className="form-input" /></div>
              <div className="form-field"><label>Apellidos</label><input type="text" value={apellidos} onChange={(e) => setApellidos(e.target.value)} className="form-input" /></div>
            </div>
          )}

          <div className="form-field">
            <label>Servicio</label>
            <select value={tipoServicio} onChange={(e) => setTipoServicio(e.target.value)} className="form-select">
              {SERVICIOS_HOGAR.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>

          <button type="submit" className="btn-update" disabled={processing}><IoSave /> Guardar Datos</button>
        </form>

        <div style={{ borderBottom: '1px dashed #cbd5e1', margin: '24px 0' }}></div>

        {/* --- GESTION DE VIGENCIA --- */}
        <p style={{ fontWeight: 700, color: '#94a3b8', fontSize: '0.8rem', textTransform: 'uppercase', marginBottom: 12 }}>Gestión de Acceso</p>

        {/* Opcion 1: Extender (Solo si no vamos a renovar full) */}
        {!isRenovating && (
          <div style={{ background: '#f8fafc', padding: 16, borderRadius: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <IoTimeOutline color="#2563eb" />
              <span style={{ fontWeight: 600, color: '#334155' }}>Extender Vigencia Actual</span>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <select value={diasExtension} onChange={(e) => setDiasExtension(e.target.value)} className="form-select" style={{ flex: 1 }}>
                <option value="1">1 Día más</option>
                <option value="3">3 Días más</option>
                <option value="7">1 Semana más</option>
              </select>
              <button type="button" onClick={handleExtender} disabled={processing} className="btn-create" style={{ margin: 0, padding: '0 16px', fontSize: '0.9rem' }}>
                Aplicar
              </button>
            </div>
          </div>
        )}

        {/* Opcion 2: Renovar Full */}
        <div style={{ marginTop: 16 }}>
          {!isRenovating ? (
            <button type="button" onClick={() => setIsRenovating(true)} className="btn-update" style={{ background: '#fff', color: '#ea580c', border: '1px solid #fdba74' }}>
              <IoRefresh /> Renovar Contrato / Fechas (Nuevo Token)
            </button>
          ) : (
            <div style={{ background: '#fff7ed', padding: 16, borderRadius: 12, border: '1px solid #fed7aa' }}>
              <h4 style={{ marginTop: 0, color: '#9a3412' }}>Renovación de Contrato</h4>
              <p style={{ fontSize: '0.85rem', color: '#c2410c' }}>Selecciona el nuevo periodo de validez. Se generará un nuevo Código QR.</p>

              <div className="form-group-grid">
                <div className="form-field">
                  <label>Nueva Fecha Inicio</label>
                  <input type="date" value={newInicio} onChange={(e) => setNewInicio(e.target.value)} className="form-input" />
                </div>
                <div className="form-field">
                  <label>Nueva Fecha Fin</label>
                  <input type="date" value={newFin} onChange={(e) => setNewFin(e.target.value)} className="form-input" />
                </div>
              </div>

              <div className="edit-actions" style={{ gridTemplateColumns: '1fr 1fr', marginTop: 12 }}>
                <button type="button" onClick={() => setIsRenovating(false)} className="btn-delete-prov" style={{ background: 'white', color: '#64748b', borderColor: '#cbd5e1' }}>Cancelar</button>
                <button type="button" onClick={handleRenovar} className="btn-create" style={{ margin: 0, background: '#ea580c' }}>Confirmar</button>
              </div>
            </div>
          )}
        </div>

        <div style={{ marginTop: 32 }}>
          <button type="button" onClick={handleDelete} className="btn-delete-prov" style={{ width: '100%' }}>
            <IoTrash /> Eliminar Proveedor
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditarProveedorScreen;